// extracted by mini-css-extract-plugin
export default {"close":"e7cjZ","modal-content":"ZJSXZ","modalContent":"ZJSXZ","modal-buttons":"dW7ft","modalButtons":"dW7ft","modal-button":"ZQGq7","modalButton":"ZQGq7"};